import { useState, useEffect } from "react";
import { useGetAllBranchesQuery } from "src/services/BranchServices";

const useBranches = () => {
  const [branches, setBranches] = useState<any[]>([]);
  const [isDataLoading, setIsDataLoading] = useState(true);

  const { data, isLoading, isFetching } = useGetAllBranchesQuery("");

  useEffect(() => {
    if (isLoading || isFetching) {
      setIsDataLoading(true);
    } else {
      const result: any[] = data?.data;
      setBranches(result || []);
      setIsDataLoading(false);
    }
  }, [data, isLoading, isFetching]);

  return { branches, isDataLoading };
};

export default useBranches;
